import { Pagination, Quote } from '@deliveries-app/models';
import { QuotePayload } from '@deliveries-app/services';
import {
  CREATE_QUOTE_FAILURE,
  CREATE_QUOTE_SUCCESS,
  DELETE_QUOTE_FAILURE,
  DELETE_QUOTE_SUCCESS,
  GET_ALL_QUOTES_FAILURE,
  GET_ALL_QUOTES_SUCCESS,
  QUOTE_REQUEST,
} from './actionTypes';

export interface QuoteReducerState {
  loading: boolean;
  message: string;
  error: string;
  errors: string[];
  _metadata?: Pagination;
  quotes: Quote[];
  quote: QuotePayload;
}

const initialState: QuoteReducerState = {
  loading: false,
  message: '',
  error: '',
  errors: [],
  _metadata: {
    page: 1,
    perPage: 2,
    total: 1,
    pages: 1,
  },
  quotes: [],
  quote: {
    delivery_fee: null,
    address: '',
    sale_type: '',
    company_name: '',
    contact_phone: '',
    contact_name: '',
    email: '',
    country: '',
    city: '',
    invoice_number: '',
    suburb: '',
    latitude: null,
    longitude: null,
  },
};

export default function quotesReducer(
  state = initialState,
  action: {
    type: string;
    payload: any;
  }
) {
  switch (action.type) {
    case QUOTE_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        errors: [],
      };
    case GET_ALL_QUOTES_SUCCESS:
      return {
        ...state,
        loading: false,
        quotes: action.payload.data,
        _metadata: action.payload._metadata,
        message: GET_ALL_QUOTES_SUCCESS,
        error: '',
      };
    case GET_ALL_QUOTES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CREATE_QUOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        quotes: [...state.quotes, action.payload],
        message: CREATE_QUOTE_SUCCESS,
        error: '',
      };
    case CREATE_QUOTE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        message: CREATE_QUOTE_FAILURE,
        errors: action.payload.errors,
      };
    case DELETE_QUOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        quotes: state.quotes.filter((quote) => quote.id !== action.payload),
        message: DELETE_QUOTE_SUCCESS,
        error: '',
      };
    case DELETE_QUOTE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
